<template>
<div>
  <ul class="nav nav-mobile-menu">
       <base-dropdown tag="li">
  <template slot="title">
    <b-icon style="font-size: 200% !important;" icon="bell-fill" aria-hidden="true"></b-icon> Overdue List
    <b class="caret"></b>
    <span class="notification" style="position: absolute; background-color: #FB404B; text-align: center; border-radius: 10px; min-width: 18px; padding: 0 5px;height: 18px; font-size: 12px; color: #FFFFFF; font-weight: bold; line-height: 18px; top: 0; left: 37px;" >{{ contractNotification.length }}</span>
  </template>
  <a v-for="(notification, index) in contractNotification" :key="index" class="dropdown-item"" style="border-bottom: 3px solid rgb(240, 206, 13, 0.937);">
    <div class="row">
      <div class="col-md-12">
        <h6>
        <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="people-fill" aria-hidden="true"></b-icon></i>
        {{ notification.tenantName }}</h6>
      </div>
      <div class="col-md-12">
        <h6>
        <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="telephone-fill" aria-hidden="true"></b-icon></i>
        {{ notification.tenantPhoneNumber }}</h6> 
      </div>
      <div class="col-md-12">
        <h6>
        <b-icon style="color: rgba(240, 206, 13, 0.937)" icon="house-fill" aria-hidden="true"></b-icon></i>
        {{ notification.houseInfo }}</h6>
      </div>
    </div>
  </a>
</base-dropdown>
    <li class="nav-item">
       <a @click="ViewAccount" class="nav-link">
          Account
        </a>
    </li>
    <li class="nav-item">
       <a @click="signOut" class="nav-link">
          Log out
        </a>
    </li>
  </ul>
  <div class="row">
        <b-modal
            id="modal-center-account-mob"
            hide-footer
            title="Account"
            content-class="shadow" 
          >
            <template #modal-header="{ close }">
              <h5>Account</h5>
              <p class="h5 mb-2">
                <b-icon
                  icon="x-square"
                  class="close-icon"
                  @click="
                    close();
                    clearData();
                  "
                ></b-icon>
              </p>
            </template>
                <b-row no-gutters>
                  <b-col xs="12" class="profile-icon">
                    <b-icon icon="person-bounding-box"></b-icon>
                  </b-col>
                </b-row>
                <b-row no-gutters class="mt-2">
                  <b-col xs="6" class="left-profile">
                    <b-row class="left-prof">First Name</b-row>
                    <b-row class="left-prof">Last Name</b-row>
                    <b-row class="left-prof">User Name</b-row>
                    <b-row class="left-prof">Phone Number</b-row>
                    <b-row class="left-prof">Email</b-row>
                  </b-col>
                  <b-col xs="4" class="right-profile">
                    <b-row class="right-prof">{{accountData.firstName}}</b-row>
                    <b-row class="right-prof">{{accountData.lastName}}</b-row>
                    <b-row class="right-prof">{{accountData.username}}</b-row>
                    <b-row class="right-prof">{{accountData.phoneNumber}}</b-row>
                    <b-row class="right-prof">{{accountData.email}}</b-row>
                  </b-col>
                </b-row>
                <b-row no-gutters class="mt-2 changePWD">
                  <b-button @click="changePassword()" class="btn-outline-primary" size="sm" style="font-weight: 700;">
                      Change Password
                  </b-button>
                </b-row>
          </b-modal>
  </div>
  <div class="row">
      <b-modal
          id="modal-center-changePwd-mob"
          hide-footer
          title="Change Password"
          content-class="shadow" 
        >
          <template #modal-header="{ close }">
            <h5>Change Password</h5>
            <p class="h5 mb-2">
              <b-icon
                icon="x-square"
                class="close-icon"
                @click="
                  close();
                  clearData();
                "
              ></b-icon>
            </p>
          </template>
          <validation-observer ref="observer" v-slot="{ handleSubmit }">
            <b-form
              class="text-left"
              @submit.stop.prevent="handleSubmit(submitChangeForm)"
            >
              <b-row no-gutters>
                <b-col
                  md="12"
                  style="justify-content: center; align-items: center"
                >
                  <Vinput
                    inputType="password"
                    :modelValue="addData.oldPassword"
                    @update:modelValue="
                      (newValue) => (addData.oldPassword = newValue)
                    "
                    :rules="{ required: true }"
                    id="text-oldPassword"
                    name="text-oldPassword"
                    label="Old Password"
                    class="mb-1 mr-sm-2"
                    description="text-oldPassword-feedback"
                    validatorName="Old Password"
                  />
                </b-col>
                <b-col
                  md="12"
                  style="justify-content: center; align-items: center"
                >
                    <Vinput
                    inputType="password"
                    :modelValue="addData.newPassword"
                    @update:modelValue="
                      (newValue) => (addData.newPassword = newValue)
                    "
                    :rules="{ required: true }"
                    id="text-newPassword"
                    name="text-newPassword"
                    label="New Password"
                    class="mb-1 mr-sm-2"
                    description="text-newPassword-feedback"
                    validatorName="New Password"
                  />
                </b-col>
                  <b-col
                  md="12"
                  style="justify-content: center; align-items: center"
                >
                    <Vinput
                    inputType="password"
                    :modelValue="addData.confirmPassword"
                    @update:modelValue="
                      (newValue) => (addData.confirmPassword = newValue)
                    "
                    :rules="{ required: true }"
                    id="text-confirmPassword"
                    name="text-confirmPassword"
                    label="Confirm Password"
                    class="mb-1 mr-sm-2"
                    description="text-confirmPassword-feedback"
                    validatorName="Confirm Password"
                  />
                </b-col>
                <b-col class="mt-2">
                  <b-button type="submit" variant="primary">Submit</b-button>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-modal>
  </div>
</div>
</template>
<script>
import Vinput from 'src/components/Inputs/Vinput.vue'
  export default {
    components: {
      Vinput
    },
    data () {
      return {
        activeNotifications: false,
        contractNotification: [],
        accountData:{
          firstName: "",
          lastName: "",
          username: "",
          email: "",
          phoneNumber: "",
          accountNumber: ""
        },
        addData: {
          userId: sessionStorage.getItem("ID"),
          newPassword: "",
          oldPassword: "",
          confirmPassword: ""
        }
      }
    },
    mounted(){
      //this.getTenantsWithPaymentStatus();
      this.ViewNotification(sessionStorage.getItem("ID"));
    },
    methods: {
      signOut(){
          this.$store.dispatch('Logout')
          .then(()=>{
              this.$router.push('/');
          })
          .catch(error =>{
              //console.log(error);
          });
      },
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      getTenantsWithPaymentStatus(){
          this.$store.dispatch('getTenantsWithPaymentStatus', {userId: sessionStorage.getItem("ID"), paymentStatus: "Unpaid"})
          .then(response=>{
              this.items = response.data;
              //console.log("item:", response.data)
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log(error);
          })
      },
      ViewAccount(){
        this.$store.dispatch('getAccountByID', {id: sessionStorage.getItem("ID")})
          .then(response=>{
            this.accountData.firstName = response.data.firstName;
            this.accountData.lastName = response.data.lastName;
            this.accountData.username = response.data.username;
            this.accountData.email = response.data.email;
            this.accountData.phoneNumber = response.data.phoneNumber;
            this.accountData.accountNumber = response.data.accountNumber;
            //console.log("some", this.accountData);
            this.$bvModal.show('modal-center-account-mob');
          })
          .catch(error=>{
              // this.$notify({
              //     title: 'Error',
              //     text: error.response.data,
              //     type: 'error'
              // })
              //console.log(error);
          })
      },
      ViewNotification(ID) {
        if(sessionStorage.getItem("mainRole") === 'OWNER'){
       this.$store.dispatch('getOverdueContractNotification', {userId: ID})
        .then(response => {
          this.contractNotification=response.data.notification;
          console.log("Notification:", response.data);
        })
        .then(data => {
          this.contractNotification = data.notification;
          //console.log("Notification data:", data);

          // Show the modal with the details
          this.$bvModal.show('modal-top-Details');
          this.clearData();

          // Show a notification to indicate that notifications have been loaded
        
        });
      }
      if(sessionStorage.getItem("mainRole") === 'COLLECTOR'){
       this.$store.dispatch('getOverdueContractNotificationOwner', {userId: ID})
        .then(response => {
          this.contractNotification=response.data.notification;
          console.log("Notification:", response.data);
        })
        .then(data => {
          this.contractNotification = data.notification;
          //console.log("Notification data:", data);

          // Show the modal with the details
          this.$bvModal.show('modal-top-Details');
          this.clearData();

          // Show a notification to indicate that notifications have been loaded
        
        });
      }
    },
      changePassword(){
        this.$bvModal.show('modal-center-changePwd-mob');
      },
      checkPasswordComplexity(password){
        let validationRegex = [
            { regex: /.{6,}/ }, // min 8 letters,
            { regex: /[0-9]/ }, // numbers from 0 - 9
            { regex: /[a-z]/ }, // letters from a - z (lowercase)
            { regex: /[A-Z]/}, // letters from A-Z (uppercase),
            { regex: /[^A-Za-z0-9]/} // special characters
        ]

        var checkValid =  true;
        validationRegex.forEach((item, i) => {
          var isValid = item.regex.test(password);
          checkValid = isValid
          return
        }); 
        return checkValid;
      },
      submitChangeForm(){
        this.$bvModal.msgBoxConfirm('Are you sure you want to change your password?', {
              title: 'Confirm',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle: 'YES',
              cancelTitle: 'NO',
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
        .then(value => {
            if(value === true){
              if(this.addData.newPassword === this.addData.confirmPassword){
                //console.log("password", this.addData.newPassword, this.checkPasswordComplexity(this.addData.newPassword));
                if(this.checkPasswordComplexity(this.addData.newPassword)){
                  this.$store.dispatch('changePassword', this.addData)
                  .then(response=>{
                      this.$notifications.notify(
                        {
                          message: `<span>Password successfully changed.</span>`,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'success'
                        })
                        this.$bvModal.hide('modal-center-changePwd-mob');
                        this.$bvModal.hide('modal-center-account-mob');
                        this.clearData();
                  })
                  .catch(error=>{
                     // console.log(error);
                      this.$notifications.notify(
                        {
                          message: error.response.data,
                          horizontalAlign: 'center',
                          verticalAlign: 'top',
                          type: 'danger'
                        })
                  })
                }else{
                  this.$notifications.notify(
                  {
                    message: `<span>Not valid password.</span>`,
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
                }
              }else{
                this.$notifications.notify(
                {
                  message: `<span>Password did not match.</span>`,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              }
            }
        })
        .catch(error=>{
           //console.log(error)
        })
      }
    }
  }
</script>
<style scoped>
.nav-item{
  cursor: pointer;
}
.profile-icon{
  font-size: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgba(240, 206, 13, 0.937);
  margin-right: 40px;
}
.left-profile{
  text-align: right;
  color: rgb(37, 91, 48);
}
.right-profile{
  border-left: 2px solid rgba(240, 206, 13, 0.937);
  padding-left: 40px;
}
.left-prof{
  justify-content: right;
  text-align: right !important;
  margin-right: 20px;
}
.right-prof{
  justify-content: left;
  text-align: left !important;
  margin-right: 5px;
}
@media (min-width: 768px) {
  .profile-icon{
    padding-right: 40px;
  }
}
.changePWD{
    display: flex;
    justify-content: center;
    align-items: center;
}
@media (min-width: 768px) {
  .changePWD{
    padding-right: 40px;
  }
}
</style>

